import { IconButton, styled } from '@mui/material';

export const StyleIconButton = styled(IconButton, {
  shouldForwardProp: (propName) => propName !== 'displayPosition',
})<{ displayPosition: number }>(({ displayPosition }) => ({
  position: 'absolute',
  top: 0,
  left: `${displayPosition}%`,
  padding: 2,
  transform: 'translateX(-50%)',
}));
